import resolveDomain from './resolve-domain';

const resolvedDomain = resolveDomain();

const serverAPI = resolvedDomain.api;
const adminHost = resolvedDomain.adminHost;

const rootStudent = serverAPI;
const rootTeacher = serverAPI;
const rootUser = serverAPI;
const rootCurriculum = serverAPI;

export const API = {
  POST: {
    addCustomLesson: `${rootTeacher}/customlesson/add`,
    updateCustomLesson: `${rootTeacher}/customlesson/update`,
    payment: {
      signup: `${rootUser}/payment/signup`,
      directSignup: `${rootUser}/user/direct`,
      updateSubscription: `${rootUser}/payment/updatesubscription`,
      updateCard: `${rootUser}/payment/updatecard`,
      cancelSubscription: `${rootUser}/payment/cancelsubscription`,
      checkCoupon: `${rootUser}/payment/couponcheck?code=`
    },
    user: {
      startResetPassword: `${rootUser}/user/startresetpassword`,
      save: `${rootUser}/user/save`, // teacher register
      saveTeacher: `${rootUser}/user/save/teacher`,
      saveGoogleTeacher: `${rootUser}/user/save/teacher/google`,
      saveStudent: `${rootUser}/user/save/student`,
      saveStudentOfTeacher: `${rootUser}/user/save/teacher/student`,
      checkSession: `${rootUser}/user/checksession`,
      updateUserPassword: `${rootUser}/user/updateuserpassword`,
      login: `${rootUser}/user/login`,
      loginImpersonate: `${rootUser}/user/impersonate`,
      loginsocial: `${rootUser}/user/loginsocial`,
      loginSocialWithCode: `${rootUser}/user/googlelogin`,
      decodeSocialCode: `${rootUser}/user/googleregistration`,
      resendVerification: `${rootUser}/user/resendverification`,
      verifyResetPasswordCode: `${rootUser}/user/verifyresetpasswordcode`,
      resetPasswordUpdate: `${rootUser}/user/resetpasswordupdate`,
      updateStudentPassword: `${rootUser}/user/updatestudentpassword`,
      updateTeacherPassword: `${rootUser}/user/updatesubteacherpassword`,
      updateShowTutorial: `${rootUser}/user/updateshowtutorial`,
      logout: `${rootUser}/user/logout`,
    }
  },
  GET: {
    getCustomLessons: `${rootTeacher}/customlesson/getCustomLessons`,
    progress: {
      getClassReport: `${rootTeacher}/progress/getclassreport`,
      getStudentReport: `${rootTeacher}/progress/getstudentreport?studentID=`,
      getSuperTeacherReport: `${rootTeacher}/progress/getsuperteacherreport`,
      getResultsCSVForStudent: `${rootTeacher}/progress/studentprogressreport?studentID=`,
      getStudentQuizResult: `${rootTeacher}/progress/getstudentquizresult?quizresultid=`,
      getPerformanceMetrics: `${rootTeacher}/progress/performance-metrics`,
    }
  },
  writingAssignment: {
    getAssignment: `${rootStudent}/writingassignment/getassignment`,
    save: `${rootStudent}/writingassignment/save`,
    getByLesson: `${rootStudent}/writingassignment/getall`
  },
  student: {
    saveQuiz: `${rootStudent}/student/savequiz`,
    savePartialQuiz: `${rootStudent}/student/save-partial-quiz`,
    startQuiz: `${rootStudent}/student/startquiz`,
    resetQuizStarts: `${rootStudent}/student/resetquizstarts`,
    create: `${rootStudent}/student/create`,
    getEarnedBadges: `${rootStudent}/student/getearnedbadges`,
    getAll: `${rootStudent}/student/search?search=`,
    deleteClass: `${rootStudent}/student/deleteclass`,
    teacherDeleteClass: `${rootStudent}/teacher/student/deleteclass`,
    addClass: `${rootStudent}/student/addclass`,
    getSuperDiagnosticQuiz: `${rootStudent}/student/getsuperdiagnostic`,
    getPartialQuizAnswers: `${rootStudent}/student/get-partial-quiz-answers`,
  },
  superTeacher: {
    getAll: `${rootUser}/user/teachers/getall`,
    searchTeacher: `${rootUser}/user/getteacher?email=`,
    removeSubTeacher: `${rootUser}/user/removesubteacher`,
    addSubTeacher: `${rootUser}/user/savesubteacher`,
  },
  course: {
    getAll: `${rootCurriculum}/course/getall`
  },
  lesson: {
    getByCourse: `${rootCurriculum}/lesson/getbycourse`,
    getAll: `${rootCurriculum}/lesson/getall`
  },
  quiz: {
    getAll: `${rootCurriculum}/quiz/getentirelist`,
    getByLesson: `${rootCurriculum}/quiz/getall`,
  },
  class: {
    getAll: `${rootTeacher}/class/getall`,
    create: `${rootTeacher}/class/save`,
    delete: `${rootTeacher}/class/delete/`,
    getCode: `${rootTeacher}/class/getcode`,
    validateCode: `${rootTeacher}/class/validatecode?code=`,
    getWaResults: `${rootTeacher}/writingassignment/getassignments?classID=`,
    saveWaResult: `${rootTeacher}/writingassignment/evaluate`,
    getSuperDiagnosticQuiz: `${rootTeacher}/class/getsuperdiagnostic`,
    updateClassSuperDiagnostic: `${rootTeacher}/class/updateClassSuperDiagnostic`,
    addStudentByEmail: `${rootTeacher}/class/addstudenttoclass`,
    resetAll: `${rootTeacher}/class/clear`,
  },
  customDiagnostic: {
    get: `${rootTeacher}/customdiagnostic/get`,
    update: `${rootTeacher}/customdiagnostic/update`
  },
  topic: {
    getAll: `${rootCurriculum}/topic/getall`
  },
  superDiagnostic: {
    canStudentTakeSuperDiagnostic: `${rootStudent}/student/can-student-take-super-diagnostic`,
    saveSuperDiagnostic: `${rootStudent}/student/savesuperdiagnostic`,
    getStudentSuperDiagnosticResult: `${rootStudent}/student/get-student-super-diagnostic-result`,
    superDiagnosticReportClass: `${rootTeacher}/progress/SuperDiagnosticReportClass`,
    superDiagnosticReportStudent: `${rootTeacher}/progress/SuperDiagnosticReportStudent`,
    superDiagnosticReportTopic: `${rootTeacher}/progress/SuperDiagnosticReportTopic`,
    superDiagnosticReportStudentAnswers: `${rootTeacher}/progress/GetSuperDiagnosticResult`
  },
  progress: {
    resetClassProgress: `${rootTeacher}/progress/resetclassprogress`,
    resetStudentProgress: `${rootTeacher}/progress/resetStudentprogress`
  },
  google: {
    createLesson: `${rootTeacher}/google/createlesson`,
    createQuiz: `${rootTeacher}/google/createquiz`,
    createWritingAssignment: `${rootTeacher}/google/createwritingassignment`,
    importStudents: `${rootTeacher}/google/studentimport`,
    importClasses: `${rootTeacher}/google/classimport`,
    getClasses: `${rootTeacher}/google/getclassesfromgoogle/`,
  },
  admin: {
    domain: adminHost,
  },
};
